@if(formGroup.get(fieldName)?.hasError('required') && formGroup.get(fieldName)?.touched) {
  <small class="p-error text-xs">
    {{displayName}} is required
  </small>
} @else if(formGroup.get(fieldName)?.hasError('minlength')  && !formGroup.get(fieldName)?.hasError('required')) {
  <small class="p-error text-xs">
    {{displayName}} should be atleast {{this.formGroup.get(fieldName)?.getError('minlength')?.requiredLength}} characters long
  </small>
} @else if( formGroup.get(fieldName)?.hasError('maxlength') && !formGroup.get(fieldName)?.hasError('required'))  {
  <small class="p-error text-xs">
    {{displayName}} should be atmost {{this.formGroup.get(fieldName)?.getError('maxlength')?.requiredLength}} characters long
  </small>
} @else if(formGroup.get(fieldName)?.hasError('email') && formGroup.get(fieldName)?.touched && formGroup.get(fieldName)?.value) {
  <small class="p-error text-xs">
    Please enter a valid email address
  </small>
} @else if(formGroup.get(fieldName)?.hasError('pattern') && !formGroup.get(fieldName)?.hasError('required')) {
  <small class="p-error text-xs">
    Please enter a valid input
  </small>
}


